import { Link } from 'react-router-dom';
import { MapPin, Phone, Mail, Facebook, Instagram, Linkedin } from 'lucide-react';

const SOCIAL_LINKS = [
  { id: 'facebook', href: 'https://www.facebook.com/propelsportsnc', Icon: Facebook, label: 'Facebook' },
  { id: 'instagram', href: 'https://www.instagram.com/propelsportsnc', Icon: Instagram, label: 'Instagram' },
  { id: 'linkedin', href: 'https://www.linkedin.com/propel-sports', Icon: Linkedin, label: 'LinkedIn' },
];

export default function Footer() {
  return (
    <footer data-testid="footer" className="bg-[#0B1D3A]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div>
            <img src="/propel-logo-footer.png" alt="Propel Sports" className="h-12 sm:h-14 w-auto mb-4" />
            <p className="text-gray-400 text-sm leading-relaxed mb-5">
              Your Indoor Community Sports Destination
            </p>
            <div className="flex gap-3">
              {SOCIAL_LINKS.map(({ id, href, Icon, label }) => (
                <a key={id} href={href} target="_blank" rel="noopener noreferrer" aria-label={label}
                  data-testid={`footer-social-${id}`}
                  className="w-9 h-9 rounded-lg bg-white/5 flex items-center justify-center text-gray-400 hover:text-[#F26522] hover:bg-[#F26522]/10 transition-all">
                  <Icon size={16} />
                </a>
              ))}
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-semibold text-white mb-4 text-sm tracking-wider">Quick Links</h4>
            <div className="space-y-2.5">
              {[
                { to: '/', label: 'Home' },
                { to: '/about', label: 'About Us' },
                { to: '/facility', label: 'Our Facility' },
                { to: '/gallery', label: 'Gallery' },
                { to: '/faq', label: 'FAQ' },
                { to: '/contact', label: 'Contact' },
              ].map(link => (
                <Link key={link.to} to={link.to} className="block text-gray-400 text-sm hover:text-[#F26522] transition-colors">
                  {link.label}
                </Link>
              ))}
            </div>
          </div>

          {/* Services */}
          <div>
            <h4 className="font-semibold text-white mb-4 text-sm tracking-wider">Services</h4>
            <div className="space-y-2.5">
              {[
                { to: '/parties', label: 'Parties & Events' },
                { to: '/batting-tunnels', label: 'Batting Tunnels' },
                { to: '/soccer-futsal', label: 'Soccer/Futsal' },
                { to: '/tournaments', label: 'Tournaments' },
              ].map(link => (
                <Link key={link.to} to={link.to} className="block text-gray-400 text-sm hover:text-[#F26522] transition-colors">
                  {link.label}
                </Link>
              ))}
              <a href="https://propelsports.myesoftplanner.com" target="_blank" rel="noopener noreferrer" className="block text-[#F26522] text-sm font-medium hover:text-[#D9551A] transition-colors">
                Book Online
              </a>
            </div>
          </div>

          {/* Contact Us */}
          <div>
            <h4 className="font-semibold text-white mb-4 text-sm tracking-wider">Contact Us</h4>
            <div className="space-y-3">
              <div className="flex items-start gap-2 text-gray-400 text-sm">
                <MapPin size={16} className="text-[#F26522] mt-0.5 shrink-0" />
                <span>810 Center St, Building #4, Apex NC, 27502</span>
              </div>
              <div className="flex items-center gap-2 text-gray-400 text-sm">
                <Phone size={16} className="text-[#F26522] shrink-0" />
                <a href="tel:+19192670943" className="hover:text-white transition-colors">(919) 267-0943</a>
              </div>
              <div className="flex items-center gap-2 text-gray-400 text-sm">
                <Mail size={16} className="text-[#F26522] shrink-0" />
                <a href="mailto:info@propelsportsnc.com" className="hover:text-white transition-colors">info@propelsportsnc.com</a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-white/10 py-6">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col sm:flex-row justify-between items-center gap-2">
          <p className="text-gray-500 text-xs">&copy; {new Date().getFullYear()} Propel Sports LLC. All rights reserved.</p>
          <Link to="/login" className="text-gray-500 text-xs hover:text-[#F26522] transition-colors">Staff Login</Link>
        </div>
      </div>
    </footer>
  );
}
